export default "__VITE_PUBLIC_ASSET__73991d20__"